exports.number = ({ value, setStatus, max }) => {
  const maxLength = max || 1000000;
  if (value >= 0 || (value <= 9 && value)) {
    if (value?.length <= maxLength) {
      setStatus(value);
    }
  }
};

exports.text = ({ value, setStatus, max }) => {
  const maxLength = max || 1000000;
  if (value?.length <= maxLength) {
    setStatus(value);
  }
};

exports.email = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(value)) {
    return true;
  } else {
    return false;
  }
};
